import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Overlay from '../../Miscelania/Overlay';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import { Modal } from 'react-bootstrap';
import getLocale from '../../../i18n/getLocale';

class ScheduleGradeObservationModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      modal: false,
      loaded: 0,
      staff_id: '',
      schedule_grade_id: '',
      date_start: '',
      date_finish: '',
      types_list: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);

    this.modalPropsOff = this.modalPropsOff.bind(this);
    this.editarObservations = this.editarObservations.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  //LM
  componentWillReceiveProps(newProps) {
    if (newProps.modal_props === true) {
      this.setState({ modal: true });
      this.setState({
        schedule_grade_id: newProps.schedule_grade_id,
        observations: newProps.observations,
      });
    } else {
      this.setState({ modal: false });
    }
  }

  modalPropsOff () {
    this.props.modalPropsOff();
  }

  editarObservations(event) {
    event.preventDefault();
    var self = this;
    this.handleAlert('', '', 'open');
    var datasave = {
      schedule_grade_id: this.state.schedule_grade_id,
      observations: this.state.observations,
    };
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/observacoes', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ modal: false });
          self.modalPropsOff();
          self.props.updateData(responseJson);
          self.handleAlert('', '', 'closed');
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg">
          <Modal.Header>
            <h4 className="pull-left">{this.locale.Escalas.EditarEscala.tabelaGrades.tituloEditarObservacoesDaGrade}</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.editarObservations}>
              <input type="hidden" name="id" className="form-control" value={this.state.id_edit} />
              <div className="form-group">
                <label>{this.locale.Escalas.EditarEscala.tabelaGrades.formularioEditarObservacoesDaGrade.Observacoes}:</label>
                <textarea style={{ height: 100}} className="form-control" type="text" name="observations" value={self.state.observations} onChange={self.handleChange.bind(self, 'observations')} />
              </div>     
              <div className="form-group">
                <button className="btn btn-primary btn-block" type="submit"><i className="fa fa-fw fa-save"></i> {this.locale.Escalas.EditarEscala.tabelaGrades.formularioEditarObservacoesDaGrade.botaoEditarObservacoesDaGrade}</button>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default ScheduleGradeObservationModal;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeObservationModal.js